export function getDateFromString(str, options = {}) {
  if (!str) return false
  if (typeof str !== 'string') {
    throw new Error(
      `Dates passed to 'getDateFromString()' need to be of type 'string', got '${typeof str}' instead.`
    )
  }
  const [year, month, day, hours = 0, minutes = 0, seconds = 0] = str.split(/[^0-9]/)
  const args = [
    parseInt(year),
    month - 1, // months are 0-indexed in JS
    parseInt(day),
    parseInt(hours),
    parseInt(minutes),
    parseInt(seconds),
  ]
  const dateObject = options.UTC ? new Date(Date.UTC(...args)) : new Date(...args)
  return dateObject
}
